import { useEffect } from 'react'

import { requestIdleCallback, cancelIdleCallback } from '@emico/utils'

/** Preloads a lazy component when the app is idle. May be used to preload chunks that are likely needed on the next navigation. */
const usePreloadLazyComponent = (component: { preload: () => unknown }) => {
  useEffect(() => {
    const id = requestIdleCallback(component.preload)

    return () => cancelIdleCallback(id)
  }, [component])
}

export default usePreloadLazyComponent
